<template>
  <div class="p-3 space-y-4">
    <form class="mb-0" @submit.prevent="createNote()">
      <div class="relative">
        <textarea
          ref="note"
          class="overflow-hidden !shadow w-full focus:outline-none resize-none rounded-md py-2 pl-2 pr-12 select-none bg-white !border border-gray-200 text-md placeholder-gray-600"
          placeholder="Create new note"
          v-model="note"
        ></textarea>
        <div
          class="absolute top-0 right-0 h-full flex justify-center items-center px-2"
        >
          <button type="submit" class="rounded-full !shadow bg-gray-700 p-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M14 5l7 7m0 0l-7 7m7-7H3"
              />
            </svg>
          </button>
        </div>
      </div>
    </form>
    <NoteItem
      v-for="note in notesDisplay"
      :key="note.id"
      :noteData="note"
      :studentId="studentInfo.dbId"
      @reloadNotes="reloadNotes()"
    />
  </div>
</template>

<script>
import { postNewStudentNote, getStudentNotes } from '../../services/api.js'
import NoteItem from '../items/NoteItem'

export default {
  props: { 
    studentInfo: {},
  },
  components: {
    NoteItem
  },
  data() {
    return {
      notes: [],
      note: '',
    }
  },
  async created() {
    this.notes = await this.getNotes()
  },
  methods: {
    async getNotes() {
      return (await getStudentNotes(this.studentInfo.dbId)).data
    },
    async createNote() {
      await postNewStudentNote(
        {
          note: this.note,
          pinned: false
        },
        this.studentInfo.dbId
      )
      this.note = ''
      this.reloadNotes()
    },
    async reloadNotes() {
      this.notes = await this.getNotes()
    },
    resizeNote() {
      this.$refs.note.style.height = 'auto'
      this.$refs.note.style.height = this.$refs.note.scrollHeight + 'px'
    },
    sortNoteCallback(a, b) {
      if (a.pinned) {
        if (b.pinned) {
          return new Date(b['created_at']) - new Date(a['created_at'])
        }
        else {
          return -1
        }
      }
      else {
        if (b.pinned) {
          return 1
        }
        else {
          return new Date(b['created_at']) - new Date(a['created_at'])
        }
      }
    }
  },
  computed: {
    notesDisplay() {
      return this.notes
        .filter(item => !item.deleted)
        .sort(this.sortNoteCallback)
        .map(note => {
          note['created_at'] = new Date(note['created_at']).toLocaleString(
            'en-US',
            {
              month: 'short',
              day: 'numeric',
              hour: '2-digit',
              minute: '2-digit'
            }
          )
          return note
        })
    },
  },
  watch: {
    note: function() {
      this.$nextTick(() => this.resizeNote())
    }
  }
}
</script>
